<template>
    <div :class="flipped ? 'card flipped' : 'card'">
        <div class="card-content">
            <div class="front">
                <slot name="front"></slot>
            </div>
            <div class="back">
                <slot name="back"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        flipped: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped>
.card {
    perspective: 1000px;
}
.card-content {
    position: relative;
}
.front,
.back {
    backface-visibility: hidden;
    transition: 1s;
    transform-style: preserve-3d;
    width: 100%;
}
.back {
    transform: rotateY(-180deg);
    position: absolute;
    top: 0;
    left: 0;
}
.card.flipped .back {
    transform: rotateY(0deg);
}
.card.flipped .front {
    transform: rotateY(180deg);
}
</style>
